import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  blocking: {
    position: 'fixed',
    top: '0px',
    left: '0px',
    zIndex: 10,
    background: 'rgba(0,0,0,0.35)',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  awaitModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    borderRadius: '10px',
    padding: '35px',
    width: '30%',
    fontWeight: 'bold'
  }
}));

const AwaitModal = ({ message = 'Espere un momento por favor.' }) => {
  const classes = useStyles();

  return (<div className={classes.awaitModal}>
    <span>{message}</span>
  </div>);
}

const BlockingPopUp = ({ children = null }) => {
  const classes = useStyles();

  return (
    <div className={classes.blocking}>
      {children == null ? <AwaitModal /> : children}
    </div>
  );
}

export default BlockingPopUp;

// Realizar:
// - Que el modal tenga un bkgcolor asi pero transparente por el alpha asi se lee bien el mensaje
// - Centrar en altura el modal